import styled, { css } from "styled-components";
import colours from "assets/colours";
import { fonts } from "assets/fontStyles";

const MonthAndYear = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 25px;
  line-height: 110%;
  letter-spacing: 0.02em;
  color: #0e1944;
  span {
    font-weight: normal;
    color: #0e1944;
  }
`;

const Header = styled.div`
  display: flex;
  width: 80%;
  justify-content: space-between;
  margin: 10px auto 20px auto;
  align-items: center;
  svg {
    width: 20px;
    cursor: pointer;
    path {
      fill: ${colours.primary};
    }
    &:first-child {
      transform: rotate(90deg);
    }
    &:last-child {
      transform: rotate(270deg);
    }
  }
`;

const StartDate = (validRange) => css`
  .react-datepicker__day.react-datepicker__day--range-start,
  .react-datepicker__day.react-datepicker__day--range-start:hover {
    background: ${(props) =>
      validRange
        ? `linear-gradient(to right, white 50%,  ${colours.primaryTinted} 50%)`
        : "transparent"};
    .custom-day {
      background: ${colours.primary};
      color: ${colours.white};
      box-shadow: 2px 3px 5px rgba(254, 77, 87, 0.2);
    }

    &.react-datepicker__day--range-end,
    &.react-datepicker__day--range-end:hover {
      background: transparent;
    }
  }
`;

const EndDate = (validRange) => css`
  .react-datepicker__day.react-datepicker__day--range-end,
  .react-datepicker__day.react-datepicker__day--range-end:hover {
    background: ${(props) =>
      validRange
        ? `linear-gradient(to left, white 50%,  ${colours.primaryTinted} 50%)`
        : "transparent"};
    .custom-day {
      background: ${colours.primary};
      color: ${colours.white};
      box-shadow: 2px 3px 5px rgba(254, 77, 87, 0.2);
    }

    &.react-datepicker__day--range-start,
    &.react-datepicker__day--range-start:hover {
      background: transparent;
    }
  }
`;

const InRangeDate = css`
  .react-datepicker__day.react-datepicker__day--in-range,
  .react-datepicker__day.react-datepicker__day--in-range:hover {
    background: ${colours.primaryTinted};
    border-radius: 0;
    .custom-day {
      background: ${colours.primaryTinted};
    }
  }
`;

const Day = (validRange) => css`
  .react-datepicker__day,
  .react-datepicker__day--today {
    width: 100%;
    margin: 0.25em 0em;
    background: ${colours.white};
    &:focus {
      outline: none;
    }
    &:hover {
      background: ${colours.white};
    }
  }

  .custom-day {
    &:hover {
      background: ${colours.grey5};
    }
  }

  .react-datepicker__day--selected {
    background: transparent;
    .custom-day {
      background: ${colours.primary};
      color: ${colours.white};
    }
  }
  .react-datepicker__day--outside-month .custom-day {
    color: ${colours.grey2};
  }
  ${InRangeDate}
  ${StartDate(validRange)}
  ${EndDate(validRange)}
`;

const CustomDay = styled.div.attrs({
  className: "custom-day",
})`
  color: ${colours.zltoDarkBlue};
  background: ${colours.white};
  font-weight: bold;
  border-radius: 100%;
  display: inline-block;
  width: 2em;
  line-height: 2em;
  height: 2em;
  text-align: center;
  margin: 0em 0.5rem;
  padding: 0.25em;
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  align-items: center;
`;

const DatePickerInput = (populated) => css`
  input {
    display: flex;
    border-radius: 3.75em;
    background: ${colours.grey4};
    padding: 0em 1.25em;
    border: none;
    height: 3.125em;
    width: inherit;
    ${fonts.input}

    &:focus,
    &:active {
      border: none;
      outline: none;
    }

    &:disabled {
      color: ${colours.grey2};
    }

    ${populated &&
    css`
      ${fonts.inputPopulated}
    `}
  }
`;

const StyledDatePicker = styled.div`
  width: 100%;
  .react-datepicker {
    border: none;
  }
  .react-datepicker__month-container {
    width: 100%;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    display: flex;
    justify-content: space-between;
    border: none;
  }

  .react-datepicker__day-name {
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 150%;
    text-align: center;
    letter-spacing: 0.02em;
    color: ${colours.primary};
    text-transform: uppercase;
  }

  .react-datepicker__header {
    border: none;
    background: white;
    padding-top: 0px;
    margin: 0.4rem;
  }

  ${({ populated }) => DatePickerInput(populated)};
  ${({ validRange }) => Day(validRange)};
`;

export {
  StyledDatePicker,
  CustomDay,
  Day,
  MonthAndYear,
  Header,
  DatePickerInput,
};
